export default "__VITE_ASSET__BmceuZMC__"